<ui-dialog
    [open]="isOpen"
    [header]="
        hasBulkUpdateFeature()
            ? 'Assign Federal Dental Benefit codes to employees'
            : 'payroll.taxReturns.haveYouReportedOnDentalCareInsuranceYet'
    "
    (closing)="closeDialog()"
>
    @if (hasBulkUpdateFeature()) {
        <!-- Copy to redirect to Dental Benefits table -->
        <div>
            @for (content of 'payroll.dental-benefits.warning-dialog.content' | translate; track content) {
                <p>
                    @if (isNestedArray(content)) {
                        @for (subContent of content; track subContent) {
                            <!-- Allows us to use a RouterLink for an internal link while also translating the copy within-->
                            @if (subContent === 'LINK_PLACEHOLDER') {
                                <a routerLink="/payroll/dental-benefits">{{
                                    'payroll.dental-benefits.warning-dialog.linkText' | translate
                                }}</a>
                            } @else {
                                {{ subContent }}
                            }
                        }
                    } @else {
                        {{ content }}
                    }
                </p>
            }
        </div>
    } @else {
        <!-- Legacy copy for year end adjuster-->
        <div
            class="margin-bottom-2"
            [innerHTML]="
                'payroll.taxReturns.startingIn2023TheCraRequiresDisclosureOfDentalCareInsuranceEligi' | translate
            "
        ></div>
    }
    <ui-dialog-footer class="margin-top-5">
        <ui-button (click)="closeDialog()" class="margin-right-auto" type="ghost">{{ 'close' | translate }}</ui-button>
        <ui-button (click)="onGenerateT4s.emit()" type="outline">{{
            'payroll.dental-benefits.warning-dialog.continueToT4sButton' | translate
        }}</ui-button>
        <ui-button
            (click)="
                router.navigate([hasBulkUpdateFeature() ? '/payroll/dental-benefits' : '/payroll/records/adjustments'])
            "
            type="primary"
            >{{
                (hasBulkUpdateFeature()
                    ? 'payroll.dental-benefits.warning-dialog.goToDentalBenefitsButton'
                    : 'payroll.taxReturns.goToYearEndAdjustmentTool'
                ) | translate
            }}</ui-button
        >
    </ui-dialog-footer>
</ui-dialog>
